export {default as FlipCard, } from "./FlipCard";
